import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          type: Yup.string()
                                                     .required('Required'),
                                          customerId: Yup.string(),
                                      });
